import {graphql, useStaticQuery} from "gatsby";

export const ArticlePhotos = () => {
  const images = useStaticQuery(graphql`
      query {
          hero: file(
              relativePath: {
                  eq: "images/blog/article_16/hero.png"
              }
          ) {
              childImageSharp {
                  fluid(maxWidth: 300, maxHeight: 300, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp_noBase64 
                  }
              }
          }

          img_1: file(
              relativePath: {
                  eq: "images/blog/article_16/img_1.png"
              }
          ) {
              childImageSharp {
                  fluid(maxWidth: 496, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
              }
          }
      }
  `);
  return images;
};
